import React, { Component } from 'react'
import Modal from '../utils/modal'
import axios from 'axios'

export default class FormRegister extends Component {
  constructor () {
    super()

    this.state = {
      wrongPassword: false,
      wrongEmail: false,
      msgPassword: '',
      msgEmail: '',
      modal: false,
      statesUF: [],
      cities: [],
      searchUF: '',
      searchCity: '',
      codeReturns: [],
      blockFieldsBySearch: false,
      cep: ''
    }
  }

  componentDidMount () {
    axios.get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados`)
      .then(res => {
        const statesUF = res.data
        this.setState({statesUF})
      })
  }

  onChangeInput (e) {
    let value = e.target.value
    const name = e.target.name

    if (name === 'cep') {
      value = this.onChangeCep(e)
    }

    this.props.onChangeInput(value, name)
  }

  onChangeCep (e) {
    let value
    value = e.target.value.replace(/\D/g, '')
    if (value.length >= 0) {
      this.setState({
        blockFieldsBySearch: false
      })
    }
    if (value.length >= 8) {
      this.autoCompleteAddress(value)
      const str = `00000000${value}`
      value = str.substr(-8).replace(/\D/g, '').replace(/(\d{5})(\d{3})/g, '$1-$2')
      return value
    }
    return value
  }

  autoCompleteAddress (value) {
    axios.get(`https://viacep.com.br/ws/${value}/json/`)
      .then(res => {
        const fullAddress = res.data
        this.props.setAddress(fullAddress)
        this.setState({
          blockFieldsBySearch: true
        })
      })
  }

  onRegisterClick () {
    this.props.onRegisterClick()
  }

  matchConfirmation (e) {
    const name = e.target.name
    const value = e.target.value
    let msg
    let target
    let msgTarget
    let toMatchField

    switch (name) {
      case 'emailConfirmation':
        msg = 'Há divergência entre os e-mails informados.'
        target = 'wrongEmail'
        msgTarget = 'msgEmail'
        toMatchField = this.props.values.email
        this.toMatchInputs(target, value, toMatchField, msg, msgTarget)
        break;
      case 'persitPassword':
        msg = 'Há divergência entre as senhas informadas.'
        target = 'wrongPassword'
        msgTarget = 'msgPassword'
        toMatchField = this.props.values.password
        this.toMatchInputs(target, value, toMatchField, msg, msgTarget)
        break;
      default:
        return
    }
  }

  toMatchInputs (target, value, toMatchField, msg, msgTarget) {
    if (toMatchField !== value) {
      return this.notMatch(target, msg, msgTarget)
    }
    this.matchSuccess(target, msgTarget)
  }

  notMatch (target, msg, msgTarget) {
    this.setState({
      [target]: true,
      [msgTarget]: msg
    })
  }

  matchSuccess (target, msgTarget) {
    this.setState({
      [target]: false,
      [msgTarget]: ''
    })
  }

  onPostalCodeClick (e) {
    e.preventDefault(e)
    this.setState({
      modal: true
    })
  }

  closeModal = () => {
    this.setState({
      modal: false
    })
  }

  renderStates (uf) {
    return (
      <option value={uf.id + '-' + uf.sigla} key={uf.id}>
        {uf.sigla} - {uf.nome}
      </option>
    )
  }

  orderingUf (elem) {
    elem.sort((a, b) => {
      if (a.sigla > b.sigla) {
        return 1
      }
      if (a.sigla < b.sigla) {
        return -1
      }
      return 0
    })
  }

  getCities (e) {
    const uf = e.target.value.split('-')

    axios.get(
      `http://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf[0]}/municipios`
    )
      .then(res => {
        const cities = res.data
        this.setState({cities})
      })

    this.setState({searchUF: uf[1]})
  }

  renderCities (cities) {
    return (
      <option value={cities.nome} key={cities.id}>
        {cities.nome}
      </option>
    )
  }

  setCurrentCity (e) {
    const city = e.target.value
    this.setState({
      searchCity: city
    })
  }

  getAddress (e) {
    e.preventDefault()

    const address = this.props.values.address
    const {searchUF, searchCity} = this.state

    axios.get(`https://viacep.com.br/ws/${searchUF}/${searchCity}/${address}/json/`)
      .then(res => {
        const codeReturns = res.data
        this.setState({codeReturns})
      })
  }

  onClickFoundedCEP (cep) {
    axios.get(`https://viacep.com.br/ws/${cep}/json/`)
      .then(res => {
        const fullAddress = res.data
        this.props.setAddress(fullAddress)
        this.setState({
          modal: false,
          blockFieldsBySearch: true
        })
      })
  }

  renderCodes (code, index) {
    const cep = code.cep
    return (
      <li className='' key={index} onClick={() => this.onClickFoundedCEP(cep)}>
        <p className='street-cep'><span>CEP:</span> {cep}</p>
        <p className='street-log'><span>Logradouro:</span> {code.logradouro}</p>
        <p className='street-com'><span>Complemento:</span> {code.complemento}</p>
        <p className='street-bai'><span>Bairro:</span> {code.bairro}</p>
        <p className='street-loc'><span>Cidade:</span> {code.localidade}</p>
        <p className='street-uf'><span>Estado:</span> {code.uf}</p>
      </li>
    )
  }

  render () {
    const isPCD = this.props.values.pcd
    const listStates = this.state.statesUF
    const listCities = this.state.cities
    const codeReturns = this.state.codeReturns

    this.orderingUf(listStates)
    return (
      <div>
        {this.state.modal ? (
          <Modal closeModal={this.closeModal}>
            <h3>Busque o CEP pelo endereço:</h3>
            <div className='search-cep'>
              <div className='row'>
                <div className='field half'>
                  <label className='label'>
                    estado*
                    <select
                      className='select'
                      onChange={(e) => this.getCities(e)}>
                      <option>Selecione</option>
                      {listStates.map((listStates) => (this.renderStates(listStates)))}
                    </select>
                  </label>
                </div>
                <div className='field half'>
                  <label className='label'>
                    cidade*
                    <select
                      className='select'
                      onChange={(e) => this.setCurrentCity(e)}>
                      <option>Selecione</option>
                      {listCities.map((listCities) => (this.renderCities(listCities)))}
                    </select>
                  </label>
                </div>
              </div>
              <div className='row'>
                <div className='field'>
                  <label className='label'>
                    logradouro*
                    <input
                      type='text'
                      name='address'
                      value={this.props.values.address}
                      className='input'
                      onChange={(e) => this.onChangeInput(e)}/>
                  </label>
                </div>
              </div>
              <div className='row'>
                <div className='field'>
                  <a
                    href=''
                    className='button primary-color'
                    onClick={(e) => this.getAddress(e)}>
                    Buscar CEP
                  </a>
                </div>
              </div>
              {this.state.codeReturns.length ? (
                <div className='row'>
                  <div className='field'>
                    <ul>
                      {codeReturns.map(
                        (codeReturns, index) => (
                          this.renderCodes(codeReturns, index)
                        )
                      )}
                    </ul>
                  </div>
                </div>
              ) : null}
            </div>
          </Modal>
          ) : null}

        <form className='clear'>
          <article>
            <fieldset>
              <legend>dados pessoais</legend>
              <div className='row'>
                <div className='field half'>
                  <label className='label'>
                    nome*
                    <input
                      type='text'
                      name='name'
                      className='input'
                      onChange={(e) => this.onChangeInput(e)}/>
                  </label>
                </div>

                <div className='field half'>
                  <label className='label'>
                    sobrenome*
                    <input
                      type='text'
                      name='lastName'
                      className='input'
                      onChange={(e) => this.onChangeInput(e)}/>
                  </label>
                </div>
              </div>

              <div className='row'>
                <div className='field'>
                  <label className='label'>
                    como você gostaria de ser chamado em sala de aula?
                    <input
                      type='text'
                      name='nickName'
                      className='input'
                      onChange={(e) => this.onChangeInput(e)}/>
                  </label>
                </div>
              </div>

              <div className='row'>
                <div className='field half'>
                  <label className='label'>
                    e-mail*
                    <input
                      type='email'
                      name='email'
                      className='input'
                      onChange={(e) => this.onChangeInput(e)}/>
                  </label>
                </div>

                <div className='field half'>
                  <label className='label'>
                    confirmação de e-mail*
                    <input
                      type='email'
                      name='emailConfirmation'
                      className='input'
                      onChange={(e) => this.onChangeInput(e)}
                      onBlur={(e) => this.matchConfirmation(e)}/>
                    {this.state.wrongEmail ? (
                      <span className='notification notification-wrong'>
                        {this.state.msgEmail}
                      </span>
                    ) : null}
                  </label>
                </div>
              </div>

              <div className='row'>
                <div className='field third'>
                  <label className='label'>
                    cpf*
                    <input
                      type='number'
                      name='cpf'
                      className='input'
                      onChange={(e) => this.onChangeInput(e)}/>
                  </label>
                </div>

                <div className='field third '>
                  <label className='label'>
                    nascimento*
                    <input
                      type='date'
                      name='birthdate'
                      className='input'
                      onChange={(e) => this.onChangeInput(e)}/>
                  </label>
                </div>

                <div className='field third'>
                  <label className='label'>
                    sexo*
                  </label>
                  <div className='fieldRadio'>
                    <label>
                      <input
                        type='radio'
                        name='gender'
                        value='man'
                        className='radio'
                        onChange={(e) => this.onChangeInput(e)} />
                      masculino
                    </label>
                    <label>
                      <input
                        type='radio'
                        name='gender'
                        value='woman'
                        className='radio'
                        onChange={(e) => this.onChangeInput(e)} />
                      feminino
                    </label>
                  </div>
                </div>
              </div>

              <div className='row'>
                <div className='field half'>
                  <label className='label'>
                    celular*
                    <input
                      type='tel'
                      name='cellphone'
                      className='input'
                      onChange={(e) => this.onChangeInput(e)}/>
                  </label>
                </div>

                <div className='field half'>
                  <label className='label'>
                    telefone
                    <input
                      type='tel'
                      name='phone'
                      className='input'
                      onChange={(e) => this.onChangeInput(e)}/>
                  </label>
                </div>
              </div>

              <div className='row'>
                <div className='field'>
                  <label className='label'>
                    possui algum tipo de deficiência ou necessidade especial?
                  </label>
                  <div className='fieldRadio'>
                    <label>
                      <input
                        type='radio'
                        name='pcd'
                        value='true'
                        className='radio'
                        onChange={(e) => this.onChangeInput(e)} />
                      sim
                    </label>
                    <label>
                      <input
                        type='radio'
                        name='pcd'
                        value='false'
                        className='radio'
                        onChange={(e) => this.onChangeInput(e)} />
                      nao
                    </label>
                  </div>
                  {isPCD === 'true' ? (
                    <label>
                      <textarea
                        name='pcdDescription'
                        placeholder='Descreva sua necessidade especial'
                        onChange={(e) => this.onChangeInput(e)}/>
                    </label>
                    ) : null }
                </div>
              </div>
            </fieldset>
          </article>

          <article>
            <fieldset>
              <legend>endereço</legend>
              <div className='row'>
                <div className='field third'>
                  <label className='label search'>
                    cep*
                    <input
                      type='text'
                      name='cep'
                      maxLength="8"
                      value={this.props.values.cep}
                      className='input'
                      onChange={(e) => this.onChangeInput(e)}/>
                      <i className="fas fa-search"></i>
                  </label>
                </div>
                <div className='field third'>
                  <a
                    href=''
                    className='button second-color small-button dontKnowCep'
                    onClick={(e) => this.onPostalCodeClick(e)}>Não sei meu CEP</a>
                </div>
              </div>
              <div className='row'>
                <div className='field half'>
                  <label className='label'>
                    logradouro*
                    <input
                      type='text'
                      name='address'
                      value={this.props.values.address}
                      className='input'
                      onChange={(e) => this.onChangeInput(e)}
                      disabled={this.state.blockFieldsBySearch ? 'disabled' : null}
                      />
                  </label>
                </div>
                <div className='field half'>
                  <label className='label'>
                    Número*
                    <input
                      type='number'
                      name='addressNumber'
                      className='input'
                      onChange={(e) => this.onChangeInput(e)}/>
                  </label>
                </div>
              </div>
              <div className='row'>
                <div className='field half'>
                  <label className='label'>
                    complemento
                    <input
                      type='text'
                      name='complement'
                      className='input'
                      onChange={(e) => this.onChangeInput(e)}/>
                  </label>
                </div>
                <div className='field half'>
                  <label className='label'>
                    bairro*
                    <input
                      type='text'
                      name='district'
                      value={this.props.values.district}
                      className='input'
                      onChange={(e) => this.onChangeInput(e)}
                      disabled={this.state.blockFieldsBySearch ? 'disabled' : null}/>
                  </label>
                </div>
              </div>
              <div className='row'>
                <div className='field half'>
                  <label className='label'>
                    cidade*
                    <input
                      type='text'
                      name='city'
                      value={this.props.values.city}
                      className='input'
                      onChange={(e) => this.onChangeInput(e)}
                      disabled={this.state.blockFieldsBySearch ? 'disabled' : null}/>
                  </label>
                </div>
                <div className='field half'>
                  <label className='label'>
                    estado*
                    <input
                      type='text'
                      name='state'
                      value={this.props.values.state}
                      className='input'
                      onChange={(e) => this.onChangeInput(e)}
                      disabled={this.state.blockFieldsBySearch ? 'disabled' : null}/>
                  </label>
                </div>
              </div>
            </fieldset>
          </article>
          <article>
            <fieldset>
              <legend>trabalho</legend>
              <div className='row'>
                <div className='field half'>
                  <label className='label'>
                    empresa*
                    <input
                      type='text'
                      name='company'
                      className='input'
                      onChange={(e) => this.onChangeInput(e)}/>
                  </label>
                </div>
                <div className='field half'>
                  <label className='label'>
                    cargo*
                    <input
                      type='text'
                      name='position'
                      className='input'
                      onChange={(e) => this.onChangeInput(e)}/>
                  </label>
                </div>
              </div>
            </fieldset>
          </article>
          <article>
            <fieldset>
              <legend>dados de acesso</legend>
              <div className='row'>
                <div className='field third'>
                  <a href="" className="buttonSocial facebook">
                    Registre-se com Facebook</a>
                </div>
                <div className='field third'>
                  <a href="" className="buttonSocial linkedin">
                    Registre-se com Linkedin</a>
                </div>
                <div className='field third'>
                  <a href="" className="buttonSocial google">
                    Registre-se com Google</a>
                </div>
              </div>
              <div className='row'>
                <p className='alignC orSign'>ou</p>
              </div>
              <div className='row'>
                <div className='field half'>
                  <label className='label'>
                    senha*
                    <input
                      type='password'
                      name='password'
                      className='input'
                      onChange={(e) => this.onChangeInput(e)}/>
                  </label>
                </div>
                <div className='field half'>
                  <label className='label'>
                    confirmação de senha*
                    <input
                      type='password'
                      name='persitPassword'
                      className='input'
                      onChange={(e) => this.onChangeInput(e)}
                      onBlur={(e) => this.matchConfirmation(e)}/>
                    {this.state.wrongPassword ? (
                      <span className='notification notification-wrong'>
                        {this.state.msgPassword}
                      </span>
                    ) : null}
                  </label>
                </div>
              </div>
            </fieldset>
          </article>
          <article>
            <fieldset>
              <legend>como ficou sabendo da hit bra?</legend>
              <div className='row'>
                <div className='field third'>
                  <label>
                      <input
                        type='checkbox'
                        className='checkbox'
                        name='whereDidYouHear_htibraSite'
                        value='site Hit Bra'
                        onChange={(e) => this.onChangeInput(e)}/>
                      Site da HIT BRA
                  </label>
                </div>
                <div className='field third'>
                  <label>
                    <input
                      type='checkbox'
                      className='checkbox'
                      name='whereDidYouHear_linkedin'
                      value='Linkedin'
                      onChange={(e) => this.onChangeInput(e)}/>
                    Linkedin
                  </label>
                </div>
                <div className='field third'>
                  <label>
                    <input
                      type='checkbox'
                      className='checkbox'
                      name='whereDidYouHear_student'
                      value='Aluno ou ex-aluno'
                      onChange={(e) => this.onChangeInput(e)}/>
                    Aluno ou ex-aluno
                  </label>
                </div>
              </div>
              <div className='row'>
                <div className='field third'>
                  <label>
                    <input
                      type='checkbox'
                      className='checkbox'
                      name='whereDidYouHear_siteSearch'
                      value='Site de busca'
                      onChange={(e) => this.onChangeInput(e)}/>
                    Site de busca
                  </label>
                </div>
                <div className='field third'>
                  <label>
                    <input
                      type='checkbox'
                      className='checkbox'
                      name='whereDidYouHear_indication'
                      value='Indicação'
                      onChange={(e) => this.onChangeInput(e)}/>
                    Indicação
                  </label>
                </div>
                <div className='field third'>
                  <label>
                    <input
                      type='checkbox'
                      className='checkbox'
                      name='whereDidYouHear_meetPerson'
                      value='Conheço o instrutor'
                      onChange={(e) => this.onChangeInput(e)}/>
                    Conheço o instrutor
                  </label>
                </div>
              </div>
              <div className='row'>
                <div className='field third'>
                  <label>
                    <input
                      type='checkbox'
                      className='checkbox'
                      name='whereDidYouHear_email'
                      value='Email'
                      onChange={(e) => this.onChangeInput(e)}/>
                    Email
                  </label>
                </div>
                <div className='field third'>
                  <label>
                    <input
                      type='checkbox'
                      className='checkbox'
                      name='whereDidYouHear_facebook'
                      value='Facebook'
                      onChange={(e) => this.onChangeInput(e)}/>
                    Facebook
                  </label>
                </div>
                <div className='field third'>
                  <label>
                    <input
                      type='checkbox'
                      className='checkbox'
                      name='whereDidYouHear_others'
                      value='Outros'
                      onChange={(e) => this.onChangeInput(e)}/>
                    Outros
                  </label>
                </div>
              </div>
            </fieldset>
          </article>
          <article>
            <div className='row'>
              <div className='formFooter'>
                <div className='esq'>
                  <p className='strong'>(*) Campos de preenchimento obrigatório</p>
                  <div className='row'>
                    <label>
                      <input
                        type='checkbox'
                        className='checkbox'
                        value='wishFromEmail'
                        name='wishFromEmail'
                        onChange={(e) => this.onChangeInput(e)}/>
                      Desejo receber, por e-mail, novidades do HIT BRA
                    </label>
                  </div>
                  <div className='row'>
                    <label>
                      <input
                        type='checkbox'
                        className='checkbox'
                        value='wishFromPartners'
                        name='wishFromPartners'
                        onChange={(e) => this.onChangeInput(e)}/>
                      Desejo receber novidades de parceiros HIT BRA
                    </label>
                  </div>
                </div>
                <div className='dir'>
                  <a
                    className='button right'
                    onClick={() => this.onRegisterClick()}>
                    CADASTRAR</a>
                </div>
              </div>
            </div>
          </article>
        </form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/register/form.js